import {
  POCompletionStatus,
  TransitStatus,
  WarehouseCheckInType,
  POCompletionStatusFilter,
  WarehouseCheckInTypeFilter,
  WarehouseCheckInStatusFilter,
  WarehouseCheckInFlaggedIssueFilter,
  POConfirmationStatusFilter,
  POConfirmationStatus,
  ClaimStatus,
  ClaimType,
  ClaimIssueType,
  ClaimUrgencyLevel,
  DAMAGE_CLAIM_TYPES,
  DISCREPANCY_CLAIM_TYPES,
  ActiveAntsPurchaseOrderStatus
} from "../types";

export class FilterHelper {
  static normalisePOCompletionStatusFilter(completionStatusFilter?: POCompletionStatusFilter): POCompletionStatus[] {
    if (completionStatusFilter === "Draft or In Progress") {
      return ["In Progress", "Draft"];
    } else if (!completionStatusFilter) {
      return ["In Progress", "Draft", "Scheduled", "Complete", "Cancelled"];
    } else {
      return [completionStatusFilter];
    }
  }

  static normalisePOConfirmationStatusFilter(
    confirmationStatusFilter?: POConfirmationStatusFilter
  ): POConfirmationStatus[] | undefined {
    if (confirmationStatusFilter === "TBC or Overdue") {
      return ["TBC", "Overdue"];
    } else if (confirmationStatusFilter === "GXO Error") {
      return undefined;
    } else if (confirmationStatusFilter === "TBC (Non-Portal)") {
      return ["TBC"];
    } else if (confirmationStatusFilter === "Overdue (Non-Portal)") {
      return ["Overdue"];
    } else {
      return confirmationStatusFilter ? [confirmationStatusFilter] : undefined;
    }
  }

  static normaliseWarehouseCheckInTypeFilter(typeFilter?: WarehouseCheckInTypeFilter): WarehouseCheckInType[] {
    if (typeFilter && typeFilter === "Purchase Order") {
      return ["PURCHASE_ORDER"];
    } else if (typeFilter && typeFilter === "Unknown Arrival") {
      return ["UNKNOWN_ARRIVAL"];
    } else {
      return ["PURCHASE_ORDER", "UNKNOWN_ARRIVAL"];
    }
  }

  static normaliseTransitStatusFilter(transitStatusFilter?: TransitStatus[]): TransitStatus[] {
    if (!transitStatusFilter || transitStatusFilter.length === 0) {
      return ["In Transit", "Partially Received"];
    }
    return transitStatusFilter;
  }

  static normaliseClaimStatusFilter(statusFilter?: ClaimStatus | ClaimStatus[]): ClaimStatus[] | undefined {
    if (!statusFilter) {
      return undefined; // No filter means all statuses
    }
    if (Array.isArray(statusFilter)) {
      return statusFilter.length > 0 ? statusFilter : undefined;
    }
    return [statusFilter];
  }
}

export const COMPLETION_STATUS_OPTIONS: POCompletionStatusFilter[] = [
  "Draft or In Progress",
  "Draft",
  "Scheduled",
  "In Progress",
  "Complete",
  "Cancelled"
];
export const NON_DRAFT_COMPLETION_STATUS_OPTIONS: POCompletionStatusFilter[] = ["In Progress", "Complete", "Cancelled"];

export const ACTIVE_ANTS_PURCHASE_ORDER_STATUS_OPTIONS: ActiveAntsPurchaseOrderStatus[] = [
  "DRAFT",
  "IN_PROGRESS",
  "COMPLETE"
];
export const CONFIRMATION_STATUS_OPTIONS: POConfirmationStatusFilter[] = [
  "TBC",
  "Overdue",
  "TBC or Overdue",
  "Confirmed",
  "In Review",
  "Voided",
  "GXO Error",
  "TBC (Non-Portal)",
  "Overdue (Non-Portal)"
];

export const CHECK_IN_STATUS_OPTIONS: WarehouseCheckInStatusFilter[] = ["Flagged", "Complete", "Resolved"];
export const CHECK_IN_TYPE_OPTIONS: WarehouseCheckInTypeFilter[] = ["Purchase Order", "Unknown Arrival"];
export const CHECK_IN_FLAGGED_ISSUE_OPTIONS: WarehouseCheckInFlaggedIssueFilter[] = [
  "Defective expiry date(s)",
  "Order quantity discrepancy",
  "Defective product(s)",
  "Unexpected product(s)",
  "Shortage",
  "Overage"
];

export const TRANSIT_STATUS_OPTIONS: TransitStatus[] = ["In Transit", "Partially Received", "Closed"];

export const CLAIM_STATUS_OPTIONS: ClaimStatus[] = ["Pending", "Under Review", "Canceled"];

export const CLAIM_TYPE_OPTIONS: ClaimType[] = Array.from(
  new Set([...DAMAGE_CLAIM_TYPES, ...DISCREPANCY_CLAIM_TYPES])
).sort();

export const CLAIM_ISSUE_TYPE_OPTIONS: ClaimIssueType[] = ["damage", "discrepancy"];

export const CLAIM_URGENCY_LEVEL_OPTIONS: ClaimUrgencyLevel[] = ["Low", "Medium", "High"];
